import styled from "styled-components";
import { font, responsive } from "../../mixins";

export const Wrapper = styled.ul`
  display: flex;
  gap: 1rem;

  li {
    position: relative;
    a {
      color: var(--text-color);
      ${font({
        fontSize: "1.2rem",
        fontWeight: 200,
        lineHeight: 1.3,
        latterSpacing: "1px",
      })}
    }
  }

  ${responsive.tablet.standard`
      display:none;
  `}
`;
